import { Controller } from 'stimulus'
import debounce from 'lodash/debounce'
import toastr from 'toastr'

export default class extends Controller {
  static targets = ['text', 'input']

  connect() {
    this.debouncedSaveInput = debounce(this.saveInput.bind(this), 1000)
  }

  edit() {
    if (!this.textTarget || !this.inputTarget) return

    this.textTarget.classList.add('hidden')
    this.inputTarget.classList.remove('hidden')
    this.inputTarget.focus()
  }

  updateInput() {
    if (this.inputTarget) this.debouncedSaveInput()
  }

  async saveInput() {
    const sequence = this.inputTarget.value.trim()
    const url = this.data.get('url')

    if (!url) {
      console.error('URL is missing or invalid.')
      return
    }

    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ task: { sequence } })
      })

      if (response.ok) {
        const jsonResponse = await response.json()
        this.textTarget.textContent = jsonResponse.sequence || '-'
        toastr.success('Sequence successfully updated!')
      } else {
        toastr.error('Failed to update the sequence.')
      }
    } catch (error) {
      toastr.error('Unexpected error occurred.')
    } finally {
      this.inputTarget.classList.add('hidden')
      this.textTarget.classList.remove('hidden')
    }
  }
}
